<div class="modal modal-full-screen fade show" style="display: block;">
	<div class="modal-dialog">
		<div class="modal-content">
			<div class="modal-header">
				<h4 class="modal-title">Add new page section</h4>
                <button type="button" class="close" data-dismiss="modal" (click)="cancel()">
                    <span aria-hidden="true">×</span>
                    <span class="sr-only">Close</span>
                </button>
			</div>
			<div class="modal-body text-start">

                    <div class="mb-3">
                        <label>Section name</label>
                        <input type="text" class="form-control bordered" [(ngModel)]="snippet.name" />
                        <span class="form-text m-b-none">
                            Give this section a short but clear name that describes the content that will be added i.e Overview text, banner image
                        </span>
                    </div>

                    <div class="row">
                        <div class="col-6">
                            <div class="mb-3">
                                <label>Padding horizontal</label>
                                <select class="form-control bordered" [(ngModel)]="snippet.paddingH">
                                    <option *ngFor="let padding of paddingsH" value="{{padding.id}}">{{padding.name}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="mb-3">
                                <label>Padding vertical</label>
                                <select class="form-control bordered" [(ngModel)]="snippet.paddingV">
                                    <option *ngFor="let padding of paddingsV" value="{{padding.id}}">{{padding.name}}</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <div class="mb-3">
                        <label>Background colour</label>
                        <select class="form-control bordered" [(ngModel)]="snippet.backgroundColour">
                            <option *ngFor="let backgroundColour of backgroundColours" value="{{backgroundColour.id}}">{{backgroundColour.name}}</option>
                        </select>
                    </div>

                    <div class="mb-3">
                        <label>Section type</label>
                        <select class="form-control bordered" [(ngModel)]="snippet.type">
                            <option [ngValue]="type.id" *ngFor="let type of types">{{type.name}}</option>
                        </select>
                        <span class="form-text m-b-none">
                            What type of content is being loaded. Images, text, video or a prebuilt plugin?
                        </span>
                    </div>

                    <div class="row" *ngIf="snippet.type === 'grid'">
                        <div class="col-4">
                            <div class="mb-3">
                                <label>Columns</label>
                                <select class="form-control bordered" [(ngModel)]="snippet.colsDesktop">
                                    <option *ngFor="let col of cols" value="{{col}}">{{col}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-4">
                            <div class="mb-3">
                                <label>Max cell height</label>
                                <input type="number" class="form-control bordered" [(ngModel)]="snippet.gridHeight" />
                            </div>
                        </div>
                        <div class="col-4">
                            <div class="mb-3">
                                <label>Add column gutters?</label>
                                <select class="form-control bordered" [(ngModel)]="snippet.gridGutters">
                                    <option [ngValue]="1">Yes</option>
                                    <option [ngValue]="0">No</option>
                                </select>
                            </div>
                        </div>
                    </div>


                    <!-- <div class="m-3">
                        <editor *ngIf="snippet.type === 'wysiwyg'" [(ngModel)]="snippet.contents" [apiKey]="this.env.tinymceApiKey" [init]="tinyInit"></editor>
                    </div> -->

                    <div class="mb-3" *ngIf="snippet.type === 'plugin'">
                        <label>Select plugin</label>
                        <select class="form-control bordered" [(ngModel)]="snippet.content">
                            <option *ngFor="let plugin of plugins" value="{{plugin.pluginKey}}">{{plugin.name}}</option>
                        </select>
                    </div>

                    <ng-container *ngIf="snippet.type === 'c2a'">
                        <div class="mb-3">
                            <label>Enter call to action text</label>
                            <input type="text" class="form-control bordered" [(ngModel)]="snippet.content" />
                        </div>

                        <div class="mb-2">
                            <a (click)="toggleValue('showNavButton')">
                                <i
                                    class="toggle fa"
                                    [ngClass]="{
                                    'fa-toggle-on text-success': snippet.showNavButton,
                                    'fa-toggle-off' : !snippet.showNavButton}"></i>
                                    Show naviation button?
                            </a>
                        </div>

                        <div *ngIf="snippet.showNavButton">
                            <label>Enter button text</label>
                            <input type="text" class="form-control bordered mb-2" [(ngModel)]="snippet.linkText" />

                            <label>Select button colour</label>
                            <select class="form-control bordered mb-2" [(ngModel)]="snippet.navButtonClass">
                                <option [ngValue]="">Please select...</option>
                                <option [ngValue]="p.id" *ngFor="let p of buttonClasses">{{p.name}}</option>
                            </select>

                            <label>Which page should the button link to?</label>
                            <select class="form-control bordered mb-2" [(ngModel)]="snippet.linkPageId">
                                <option [ngValue]="0">Please select...</option>
                                <option [ngValue]="p.id" *ngFor="let p of pages">{{p.name}}</option>
                            </select>
                        </div>

                    </ng-container>

                    <div class="mb-3" *ngIf="snippet.type === 'video'">
                        <label>Video URL</label>
                        <input type="text" class="form-control bordered" [(ngModel)]="snippet.content" />
                        <span class="form-text m-b-none">
                            Enter the Youtube video id (last part of URL)
                        </span>
                    </div>

                    <div class="mb-3" *ngIf="snippet.type === 'gallery'">
                        <label>Select the gallery you would like to insert</label>
                        <select class="form-control bordered" [(ngModel)]="snippet.gallery">
                            <option [ngValue]="''">Please select</option>
                            <option [ngValue]="gallery.id" *ngFor="let gallery of galleries">{{gallery.name}}</option>
                        </select>
                    </div>


                    <ng-container *ngIf="snippet.type === 'image'">
                        <div class="mb-3">
                            <label>Does this link to an external page?</label>
                            <select class="form-control bordered" [(ngModel)]="snippet.external">
                                <option [ngValue]="1">Yes</option>
                                <option [ngValue]="0">No</option>
                            </select>
                        </div>

                        <div class="mb-3" *ngIf="snippet.external === 1">
                            <label>External Page URL</label>
                            <input type="text" class="form-control bordered" [(ngModel)]="snippet.externalURL" />
                            <span class="form-text m-b-none">
                                Copy and paste the link of the website page you are linking to.
                            </span>
                        </div>

                        <div class="mb-3" *ngIf="snippet.external === 0">
                            <label>Link to a page</label>
                            <select class="form-control bordered" [(ngModel)]="snippet.routeToLink">
                                <option value="">Select page</option>
                                <option [ngValue]="p.route" *ngFor="let p of pages">{{p.name}}</option>
                            </select>
                        </div>

                    </ng-container>

                    <button type="button" class="btn btn-primary" (click)="save()">Add to page</button>

			</div>

		</div>
	</div>
</div>
<div class="modal-backdrop fade show"></div>
